import { refreshAccessToken } from '.';
import { isAccessTokenExpired } from './isAccessTokenExpired';

export const getAccessToken = async (): Promise<string | null> => {
  if (isAccessTokenExpired(10000)) {
    await refreshAccessToken();
  }
  return localStorage.getItem('accessToken');
};
